import React, { useState } from 'react';
import Twitter from '../icons/Twitter';
import Facebook from '../icons/Facebook';

export default function ShareButton({ className }) {
  const [ open, setOpen ] = useState(false);
  return (
  <button
    className={`share-button h44 curp bgc-transparent bd2-s-black df aic jcc p10 ${open ? 'share-button--open' : ''} ${ className || '' }`}
    type="button"
    onClick={() => setOpen(!open)}
  >
    {open &&
    <>
      <a className="tdn" href={`https://twitter.com/intent/tweet?text=${encodeURI(window.location.href)}`} target="_blank" rel="noopener noreferrer">
        <Twitter className="h20 mr10"/>
      </a>
      <a className="tdn" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(window.location.href)}`} target="_blank" rel="noopener noreferrer">
        <Facebook className="h20 mr10"/>
      </a>
    </>
    }
    <span className="fw500 fz14 fz12@sm ttu mr4 ff-gr">Share</span>
    <span className="fw500 fz14 fz12@sm fz16 fz14@sm">{open ? '-' : '+'}</span>
  </button>
  )
}